module.exports = __webpack_public_path__ + "static/img/hausn2.6be1c6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/hausn2.jpg
// module id = rAyp
// module chunks = 1